import { render, staticRenderFns } from "./topicTaolun.vue?vue&type=template&id=2c41c2b1"
import script from "./topicTaolun.vue?vue&type=script&lang=js"
export * from "./topicTaolun.vue?vue&type=script&lang=js"
import style0 from "./topicTaolun.vue?vue&type=style&index=0&id=2c41c2b1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports